import {
  Grid,
  Select,
  MenuItem,
  TextField,
  DatePicker,
} from "../../../../components";

const FormFiltroAvancado = ({
  valueInput,
  onChangeInput,
  onChangeDate,
  valueDate,
}) => {
  const listaStatus = [
    {
      label: "Enviado",
      value: "ENVIADA",
      cor: "#4FBB53",
    },
    {
      label: "Cancelado",
      value: "CANCELADO",
      cor: "#DC3545",
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Select
          id="status"
          name="status"
          value={valueInput("status")}
          label="Status"
          onChange={(event) => onChangeInput(event)}
          fullWidth
        >
          {listaStatus.map((status, index) => (
            <MenuItem key={index} value={status.value}>
              <i
                className="ph-fill ph-circle"
                style={{ color: `${status.cor}` }}
              ></i>
              &nbsp;{status.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={6}>
        <TextField
          id="descricaoEvento"
          name="descricaoEvento"
          label="Descrição do Evento"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("descricaoEvento")}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="createdAtStart"
          name="createdAtStart"
          label="Data do Evento De"
          format="dd/MM/yyyy"
          value={valueDate("createdAtStart")}
          onChange={(date) => onChangeDate("createdAtStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="createdAtEnd"
          name="createdAtEnd"
          label="Data do Evento Até"
          format="dd/MM/yyyy"
          value={valueDate("createdAtEnd")}
          onChange={(date) => onChangeDate("createdAtEnd", date)}
        />
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
